import Charts from "react-apexcharts";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { FinanceHeading } from "../../../Constant";
import { OPTIONS_COLUMNS_DATA } from "../../../Data/Widgets/ChartWidgets";

const Finance = () => {
  return (
    <Col xl="5" lg="12" className="box-col-12">
      <Card>
        <CommonCardHeader title={FinanceHeading} className="border-bottom-1" />
        <CardBody>
          <div className="chart-container column-container">
            <div id="columnchart">
              <Charts options={OPTIONS_COLUMNS_DATA} series={OPTIONS_COLUMNS_DATA.series} height={350} type="line"/>
            </div>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Finance;
